export default __webpack_public_path__ + "static/media/FIAssembly-04.4dbef0c6.png";